import { useQuery } from '@tanstack/react-query';
import { ArgumentT } from 'routes/BudgetModule/config/types';
import { RQAPICallWithData } from 'store/APIClient';

/**
 * A custom hook for fetching arguments related to budget names by exercice.
 *
 * @param {string} budgetNames - The names of the budgets for which arguments are to be fetched.
 * @param {number} exercice - The exercise (year) for which arguments are to be fetched.
 * @returns {useQuery} - The result of the useQuery hook, containing the arguments data.
 */
const useGetArgumentsByBudgetsByExercice = (
    exercice: number,
    shouldFetch?: boolean,
    budgetNames?: string | null,
) => {
    const endpoint = budgetNames
        ? `budget_proposals/arguments/filter?exercice=${exercice}&budget_names=${budgetNames}`
        : `budget_proposals/arguments/filter?exercice=${exercice}`;
    return useQuery({
        queryKey: ['arguments', exercice, budgetNames],

        queryFn: async () => {
            const response = await RQAPICallWithData<ArgumentT[]>({
                endpoint: endpoint,
                method: 'GET',
            });
            return response.content.data;
        },

        enabled: shouldFetch,
    });
};

export default useGetArgumentsByBudgetsByExercice;
